import bridge from 'libs/bridge';
import urlParams from 'libs/query';
import { counter } from 'utils/slardar';

export function noop() {}

export function back() {
    if (bridge.supports('close')) {
        bridge.call('close');
        return;
    }
    history.back();
}

/**
 * 获取小程序跳过来的订单携带的参数
 */
export function getMicroAppParams() {
    const entranceInfoString = decodeURIComponent(urlParams.entrance_info || '');
    let entranceInfo: any = {};
    if (entranceInfoString) {
        try {
            entranceInfo = JSON.parse(entranceInfoString) || {};
        } catch (err) {
            // do nothing
            return {};
        }
    }
    return {
        openId: entranceInfo.open_id,
        appId: entranceInfo.app_id
    };
}

// 直播推荐侧埋点参数
export function getLiveEventParams() {
    try {
        const entranceInfoString = decodeURIComponent(urlParams.entrance_info || '');
        let entranceInfo: any = null;
        if (entranceInfoString) {
            try {
                entranceInfo = JSON.parse(entranceInfoString) || {};
            } catch (err) {
                // do nothing
            }
        }

        let liveEvent: any = {};
        if (entranceInfo) {
            liveEvent = {
                live_author_id: entranceInfo.anchor_id || '',
                live_room_id: entranceInfo.room_id || '',
                live_video_id: entranceInfo.group_id || '',
                live_enter_from_merge: entranceInfo.enter_from_merge || '',
                live_enter_method: entranceInfo.enter_method || '',
                live_request_id: entranceInfo.request_id || ''
            };
        }

        return liveEvent;
    } catch (err) {
        counter('error_parse_entranceinfo', {
            tags: {
                error: err.message || 'unknown',
                raw: urlParams.entrance_info
            }
        });

        return {};
    }
}
